$(document).ready(function () {
    $('#build_groups').click(function () {
        $(this).prop('disabled', true).html('Building groups ..... please wait <i class="icon icon-spinner icon-spin"></i>');
    });
    $('#build_timetables').click(function () {
        $(this).prop('disabled', true).html('Building timetables ..... please wait <i class="icon icon-spinner icon-spin"></i>');
    });
});
